export default __webpack_public_path__ + "static/media/Politicas_de_Privacidad_Soluciones.3357dce8.pdf";